// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    position: relative;
    padding: 60px 20px 30px;
    background-color: #f1f3f6;
    color: #333;
  }
  
  .footer-curve {
    position: absolute;
    top: -80px;
    left: 0;
    width: 100%;
    height: 80px;
    overflow: hidden;
  }
  
  .footer-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: 1200px;
    margin: 0 auto;
    padding-top: 60px;
    gap: 30px;
  }
  
  .footer-logo-section {
    flex: 1 1;
    min-width: 250px;
    text-align: left;
  }
  
  .footer-logo {
    width: 120px;
    height: auto;
    margin-bottom: 15px;
  }
  
  .social-text {
    margin: 20px 0 10px;
    font-weight: bold;
  }
  
  .social-icons {
    display: flex;
    gap: 15px;
  }
  
  .social-icons img {
    width: 30px;
    height: 30px;
    filter: brightness(0.3);
    transition: all 0.3s ease;
  }
  
  .social-icons img:hover {
    filter: brightness(1);
  }
  
  .footer-links {
    display: flex;
    flex: 2 1;
    justify-content: space-around;
    gap: 20px;
  }
  
  .footer-column {
    text-align: left;
  }
  
  .footer-column h4 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  
  .footer-column a {
    font-size: 14px;
    color: #333;
    text-decoration: none;
    margin-bottom: 5px;
    display: block;
  }
  
  .footer-column a:hover {
    text-decoration: underline;
  }
  
  /* Footer bottom */
  .footer-content, .footer-bottom {
    text-align: center;
    margin-top: 20px;
  }
  
  .footer-bottom {
    padding-top: 10px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,SAAO;IACP,6BAA6B;IAC7B,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,kBAAkB;EAClB;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB","sourcesContent":[".footer {\n    position: relative;\n    padding: 60px 20px 30px;\n    background-color: #f1f3f6;\n    color: #333;\n  }\n  \n  .footer-curve {\n    position: absolute;\n    top: -80px;\n    left: 0;\n    width: 100%;\n    height: 80px;\n    overflow: hidden;\n  }\n  \n  .footer-content {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding-top: 60px;\n    gap: 30px;\n  }\n  \n  .footer-logo-section {\n    flex: 1;\n    min-width: 250px;\n    text-align: left;\n  }\n  \n  .footer-logo {\n    width: 120px;\n    height: auto;\n    margin-bottom: 15px;\n  }\n  \n  .social-text {\n    margin: 20px 0 10px;\n    font-weight: bold;\n  }\n  \n  .social-icons {\n    display: flex;\n    gap: 15px;\n  }\n  \n  .social-icons img {\n    width: 30px;\n    height: 30px;\n    filter: brightness(0.3);\n    transition: all 0.3s ease;\n  }\n  \n  .social-icons img:hover {\n    filter: brightness(1);\n  }\n  \n  .footer-links {\n    display: flex;\n    flex: 2;\n    justify-content: space-around;\n    gap: 20px;\n  }\n  \n  .footer-column {\n    text-align: left;\n  }\n  \n  .footer-column h4 {\n    font-size: 16px;\n    font-weight: bold;\n    margin-bottom: 10px;\n  }\n  \n  .footer-column a {\n    font-size: 14px;\n    color: #333;\n    text-decoration: none;\n    margin-bottom: 5px;\n    display: block;\n  }\n  \n  .footer-column a:hover {\n    text-decoration: underline;\n  }\n  \n  /* Footer bottom */\n  .footer-content, .footer-bottom {\n    text-align: center;\n    margin-top: 20px;\n  }\n  \n  .footer-bottom {\n    padding-top: 10px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
